import { render, staticRenderFns } from "./DetailThree.vue?vue&type=template&id=659eddb7&scoped=true"
import script from "./DetailThree.vue?vue&type=script&lang=ts"
export * from "./DetailThree.vue?vue&type=script&lang=ts"
import style0 from "./DetailThree.vue?vue&type=style&index=0&id=659eddb7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659eddb7",
  null
  
)

export default component.exports